<template>
  <div
    class="px-5 py-3 text-n-0 rounded cursor-pointer border"
    :class="{
      'bg-n-700 border-n-600': !selected,
      'bg-v-300 border-v-400': selected
    }"
  >
    <div class="pb-2">
      {{ promotion.name }}
    </div>
    <div class="text-xs">
      <span v-if="promotion.discountType === 'percentage'"> {{ promotion.discountAmount }}% </span>
      <span v-else>
        {{ currency(promotion.discountAmount!) }}
      </span>
      {{ t('bill-discount.of-discount') }}
    </div>
    <p v-if="promotion.remainingRedemptions">
      {{ promotion.remainingRedemptions + ' ' + t('bill-discount.remaining-redemptions') }}
    </p>
    <div v-if="promotion.pointsExpense" class="mt-2 text-right text-g-300">
      {{ promotion.pointsExpense || 0 }}
      {{ t('bill-discount.points') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { useMoney } from '@/composables/useMoney'
import type { Promotion } from '@/types'

interface Props {
  promotion: Promotion
  selected: boolean
}

defineProps<Props>()

const { t } = useI18n()
const { currency } = useMoney()
</script>
